import socialTwitter from 'media/social-twitter.svg'
import socialInstagram from 'media/social-instagram.svg'
import socialYoutube from 'media/social-youtube.svg'
import socialFacebook from 'media/social-facebook.svg'
import React from 'react'
import PropTypes from 'prop-types'

class SocialMediaLinks extends React.Component {
  constructor(props) {
    super(props)
  }

  render = () => (
    <div
      className={
        this.props.inList
          ? 'c-socmed-links c-socmed-links--in-list'
          : 'c-socmed-links'
      }
    >
      <h2 className="c-socmed-links__heading">Find us elsewhere</h2>
      <ul className="c-socmed-links__list">
        <li className="c-socmed-links__item c-socmed-links__item--facebook">
          <a
            className="c-socmed-links__link"
            href="https://www.facebook.com/Lifesum"
          >
            <span className="c-socmed-links__text">Get the latest on</span>
            <img
              className="c-socmed-links__logo"
              src={socialFacebook}
              alt="Facebook"
            />
          </a>
        </li>
        <li className="c-socmed-links__item c-socmed-links__item--youtube">
          <a
            className="c-socmed-links__link"
            href="https://www.youtube.com/channel/UCy64gY3TCURHxigExH0cHIg"
          >
            <span className="c-socmed-links__text">Enjoy our videos on</span>
            <img
              className="c-socmed-links__logo"
              src={socialYoutube}
              alt="YouTube"
            />
          </a>
        </li>
        <li className="c-socmed-links__item c-socmed-links__item--instagram">
          <a
            className="c-socmed-links__link"
            href="https://www.instagram.com/lifesum"
          >
            <span className="c-socmed-links__text">Get inspired on</span>
            <img
              className="c-socmed-links__logo"
              src={socialInstagram}
              alt="Instagram"
            />
          </a>
        </li>
        <li className="c-socmed-links__item c-socmed-links__item--twitter">
          <a
            className="c-socmed-links__link"
            href="https://twitter.com/lifesum"
          >
            <span className="c-socmed-links__text">Stay up to date on</span>
            <img
              className="c-socmed-links__logo"
              src={socialTwitter}
              alt="Twitter"
            />
          </a>
        </li>
      </ul>
    </div>
  )
}

SocialMediaLinks.deaultProps = {
  inList: false,
}

SocialMediaLinks.propTypes = {
  inList: PropTypes.bool,
}

export default SocialMediaLinks
